<template>
    <div class="flex flex-col">
        <h1>Subir certificados de productos</h1>
        <br>
        <form @submit.prevent="subirPdf">
            <input type="file" @change="handleFile" accept="application/pdf" />
            <br>
            <button :disabled="cargando" class="btn btn-danger mt-5" style="background-color: red;" type="submit">Subir PDF</button>
        </form>

        <table class="table-auto border-collapse border border-gray-400 mt-5">
          <thead>
            <tr>
              <th class="border border-gray-300 px-4 py-2">Nombre</th>
              <th class="border border-gray-300 px-4 py-2">Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(certificado, index) in certificados" :key="index" class="hover:bg-gray-100 cursor-pointer" @click="descargarCertificado(certificado.nombre)">
              <td class="border border-gray-300 px-4 py-2">{{ certificado.nombre }}</td>
              <td class="border border-gray-300 px-4 py-2">{{ formatFecha(certificado.fecha) }}</td>
            </tr>
          </tbody>
        </table>
    </div>
  </template>
  
  <script>
import pedidosService from '@/services/pedidos.service';

  export default {
    data() {
      return {
        archivo: null,
        cargando: false,
        certificados: []
      };
    },
    mounted() {
      pedidosService.getAllCertificados()
        .then(response => {
          this.certificados = response.data;
        })
        .catch(error => {
          console.error("Error al obtener categorías:", error);
        });
    },
    methods: {
      descargarCertificado(nombre) {
        pedidosService.getCertificadoNombre(nombre)
          .then(res => {
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', 'certificado.pdf'); // Set the filename for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((er) => {
            alert('No se encontro el certificado')
            console.log(er)
          })
          .finally(() => {
            this.cargando = false
          })
      },
      handleFile(event) {
        this.archivo = event.target.files[0];
      },
      async subirPdf() {
        this.cargando = true
        if (!this.archivo) return alert("Selecciona un archivo PDF.");
  
        const formData = new FormData();
        formData.append("file", this.archivo);
  
        try {
          const response = await pedidosService.subirCertificado(formData)
  
          if (response.data) {
            alert("Archivo subido correctamente");
            this.archivo = ''
            this.$root.alertSuccess = true
            this.$root.isAlertVisible = true
            // Refresh certificados list after upload
            this.loadCertificados();
          } else {
            alert("Error al subir archivo");
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          }
        } catch (error) {
          console.error("Error al subir:", error);
          alert("Error interno");
          this.$root.alertSuccess = false
          this.$root.isAlertVisible = true
        } finally {
            this.cargando = false
        }
      },
      loadCertificados() {
        pedidosService.getAllCertificados()
          .then(response => {
            this.certificados = response.data;
          })
          .catch(error => {
            console.error("Error al obtener categorías:", error);
          });
      },
      formatFecha(fecha) {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString();
      }
    }
  };
  </script>
